<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>Thông tin bằng sáng chế<!--專利權資訊--></h1>
        </div>
      </header>
      <HeaderNav activeLink="patents" />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">
              【Tên sáng chế】Thức uống bổ dưỡng protein hạt nhân hòa tan trong nước
              <!--【發明名稱】水溶性核蛋白保健飲料-->
              <br />
              <span class="patent-number">(Bằng sáng chế số 3899436)</span><!--(專利第3899436號)-->
            </h2>
            <p>
              Bằng sáng chế này tương đương với bằng sáng chế về thành phần, cấp bằng sáng chế cho công thức thành phần. Dữ liệu được liệt kê dựa trên 
              kết quả nghiên cứu chung của Viện Khoa học Đời sống và FORDAYS. Các công ty khác có thể không bán sản phẩm đủ tiêu chuẩn như mặt hàng được yêu cầu.
              <!--本專利相當於組成物專利，是將成分配方專利化。所列數據乃基於生命科學研究所和FORDAYS公司共同的研究成果。其他公司不得銷售符合請求項目的產品。-->
            </p>
            <p>
              Bằng sáng chế này được cấp để đảm bảo tính nguyên gốc của sản phẩm và tránh việc bán các sản phẩm tương tự và hàng giả. Nó không ám chỉ tính 
              hiệu quả hoặc hiệu quả của thực phẩm.
              <!--本專利是為了確保產品的獨創性，並避免類似品‧仿冒品的販售而獲得的專利，並不影射食品的有效性或功效。-->
            </p>
            <ul class="attention-list">
              <li>
                Hàn Quốc và Trung Quốc cũng đã nhận được bằng sáng chế có nội dung tương tự.
                <!--韓國‧中國也同樣取得相同內容的專利。-->
              </li>
              <li>
                Thức uống axit nucleic collagen hòa tan trong nước hiện nay không phù hợp với bằng sáng chế này do làm tăng hàm lượng vitamin C.
                <!--現行的水溶性膠原核酸飲品，因維生素C增量，不適用於該專利。-->
              </li>
            </ul>
            <table class="light-table mt-4">
              <tr>
                <th width="22%">Số bằng sáng chế<!--專利編號--></th>
                <td class="font-weight-bold">Bằng sáng chế số 3899436<!--專利第3899436號--></td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/3899436.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/3899436.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>Tên sáng chế<!--發明名稱--></th>
                <td>Thức uống sức khỏe nucleoprotein hòa tan trong nước<!--水溶性核蛋白保健飲料--></td>
              </tr>
              <tr>
                <th>Ngày đăng nhập<!--登錄日期--></th>
                <td>Ngày 12 tháng 1 năm 2007<!--2007年1月12日--></td>
              </tr>
              <tr>
                <th>Số đơn đăng ký<!--申請編號--></th>
                <td>
                  Số đơn xin cấp bằng sáng chế<!--發明專利申請編號--> <br />
                  2002-135576
                </td>
              </tr>
              <tr>
                <th>Ngày nộp đơn<!--申請日--></th>
                <td>Ngày 10 tháng 5 năm 2002<!--2002年5月10日--></td>
              </tr>
              <tr>
                <th>chủ sở hữu bằng sáng chế<!--專利權所有人--></th>
                <td>
                  Công ty TNHH FORDAYS<!--FORDAYS株式會社--> <br />
                  Công ty TNHH LS<!--LS株式會社-->
                </td>
              </tr>
            </table>

            <table class="light-table mt-4">
              <tr>
                <th width="22%">Số bằng sáng chế<!--專利編號--></th>
                <td class="font-weight-bold">ZL 2004 8 0000957.0</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/cn_zl_2004.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/cn_zl_2004.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>Tên sáng chế<!--發明名稱--></th>
                <td>thức uống tốt cho sức khỏe<!--保健飲料--></td>
              </tr>
              <tr>
                <th>Ngày đăng nhập<!--登錄日期--></th>
                <td>Ngày 15 tháng 4 năm 2009<!--2009年4月15日--></td>
              </tr>
              <tr>
                <th>Số đơn đăng ký<!--申請編號--></th>
                <td>200480000957.0</td>
              </tr>
              <tr>
                <th>Ngày nộp đơn<!--申請日--></th>
                <td>Ngày 28 tháng 12 năm 2004<!--2004年12月28日--></td>
              </tr>
              <tr>
                <th>chủ sở hữu bằng sáng chế<!--專利權所有人--></th>
                <td>
                  Công ty TNHH FORDAYS<!--FORDAYS株式會社--> <br />
                  Công ty TNHH LS<!--LS株式會社-->
                </td>
              </tr>
            </table>

            <table class="light-table mt-4 mb-4">
              <tr>
                <th width="22%">Số bằng sáng chế<!--專利編號--></th>
                <td class="font-weight-bold">10-0688867</td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/ko_10-0688867.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/ko_10-0688867.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>Tên sáng chế<!--發明名稱--></th>
                <td>thức uống tốt cho sức khỏe<!--保健飲料--></td>
              </tr>
              <tr>
                <th>Ngày đăng nhập<!--登錄日期--></th>
                <td>Ngày 22 tháng 2 năm 2007<!--2007年2月22日--></td>
              </tr>
              <tr>
                <th>Số đơn đăng ký<!--申請編號--></th>
                <td>KR20057005564</td>
              </tr>
              <tr>
                <th>Ngày nộp đơn<!--申請日--></th>
                <td>Ngày 30 tháng 3 năm 2005<!--2005年3月30日--></td>
              </tr>
              <tr>
                <th>chủ sở hữu bằng sáng chế<!--專利權所有人--></th>
                <td>
                  Công ty TNHH FORDAYS<!--FORDAYS株式會社--> <br />
                  Công ty TNHH LS<!--LS株式會社-->
                </td>
              </tr>
            </table>

            <h2 class="section-title">
              【Tên sáng chế】Đồ uống tốt cho sức khỏe có chứa cystein
              <!--【發明名稱】含有半胱胺酸肽的保健飲料-->
              <br />
              <span class="patent-number">(Bằng sáng chế số 6138048)<!--(專利第6138048號)--></span>
            </h2>
            <p>
              Bằng sáng chế này dành cho đồ uống tốt cho sức khỏe dựa trên các thành phần cụ thể. Áp dụng cho đồ uống axit nucleic collagen hòa tan trong nước hiện nay.
              <!--本專利是以特定的配合成分為基礎而製成的保健飲品之專利。適用於現行的水溶性膠原核酸飲品。-->
              <br />
              Bằng sáng chế này dựa trên kết quả nghiên cứu chung của Viện Khoa học Đời sống và FORDAYS. Các công ty khác có thể không bán sản phẩm đủ tiêu chuẩn như mặt hàng được yêu cầu.
              <!--本專利乃基於生命科學研究所和FORDAYS公司共同的研究成果。其他公司不得銷售符合請求項目的產品。-->
              <br />
              Bằng sáng chế này được cấp để đảm bảo tính nguyên gốc của sản phẩm và tránh việc bán các sản phẩm tương tự và hàng giả. Nó không ám chỉ tính hiệu quả hoặc hiệu quả của thực phẩm.
              <!--本專利是為了確保產品的獨創性，並避免類似品‧仿冒品的販售而獲得的專利，並不影射食品的有效性或功效。-->
            </p>

            <table class="light-table mt-4 mb-4">
              <tr>
                <th width="22%">Số bằng sáng chế<!--專利編號--></th>
                <td class="font-weight-bold">Bằng sáng chế số 6138048<!--專利第6138048號--></td>
                <td width="20%" rowspan="6">
                  <VuePureLightbox
                    :thumbnail="
                      require('@/assets/public/images/patent/6138048.jpg')
                    "
                    :images="[
                      require('@/assets/public/images/patent/6138048.jpg'),
                    ]"
                  />
                </td>
              </tr>
              <tr>
                <th>Tên sáng chế<!--發明名稱--></th>
                <td>Đồ uống sức khỏe có chứa cysteine<!--含有半胱胺酸肽的保健飲料--></td>
              </tr>
              <tr>
                <th>Ngày đăng nhập<!--登錄日期--></th>
                <td>Ngày 12 tháng 5 năm 2017<!--2017年5月12日--></td>
              </tr>
              <tr>
                <th>Số đơn đăng ký<!--申請編號--></th>
                <td>
                  Số đơn xin cấp bằng sáng chế<!--發明專利申請編號-->  <br />
                  2013-538440
                </td>
              </tr>
              <tr>
                <th>Ngày nộp đơn<!--申請日--></th>
                <td>Ngày 11 tháng 10 năm 2012<!--2012年10月11日--></td>
              </tr>
              <th>chủ sở hữu bằng sáng chế<!--專利權所有人--></th>
                <td>Công ty TNHH FORDAYS<!--FORDAYS株式會社--></td>
            </table>

            <h2 class="section-title">
              Về các bằng sáng chế khác<!--關於其他專利--> <br />
              (Bằng sáng chế số 6153736, Bằng sáng chế số 5820127)<!--(專利第6153736號、專利第5820127號)-->
            </h2>
            <p>
              Bằng sáng chế này có được dựa trên bằng chứng được phát hiện thông qua nghiên cứu chung giữa FORDAYS và Đại học Showa, dựa trên một khám phá chức năng mới và độc đáo.
              <!--本專利基於具有新穎且獨創性的機能性的發現，並根據FORDAYS和昭和大學的共同研究中所發現的證據而獲得專利。-->
              Những dữ liệu này thuộc về FORDAYS. Thức uống axit nucleic collagen hòa tan trong nước hiện nay có thể áp dụng cho mọi yêu cầu bảo hộ trong bằng sáng chế này. 
              Mặc dù các bằng sáng chế này là một phần trong nỗ lực nghiên cứu của chúng tôi nhưng chúng không ám chỉ tính hiệu quả hoặc hiệu quả của thực phẩm.
              <!--這些數據資料屬於FORDAYS公司。現行中的水溶性膠原核酸飲品適用於本專利中的每個請求項目。雖然這些專利是我們致力研究成果的一部分，但不影射食品的有效性或功效。-->
            </p>
            <p style="font-size: 14px">
              ※ Sản phẩm này không phải là thuốc và không dùng để chữa bệnh nhưng có ý nghĩa tích cực trong việc duy trì sức khỏe hàng ngày. 
              Vui lòng tuân thủ các quy định quản lý an toàn thực phẩm và không phóng đại hoặc đưa ra tuyên bố sai sự thật về hiệu quả để tránh vi phạm pháp luật!
              <!--※ 本產品不是藥物，不是用於疾病的治療，但對於日常保養有積極的意義。請遵守食品安全管理辦法，切勿誇大不實或宣稱療效，以免觸法！-->
            </p>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
import VuePureLightbox from "vue-pure-lightbox";
export default {
  name: "PatentsScreen",
  components: {
    PublicLayout,
    HeaderNav,
    VuePureLightbox,
  },
};
</script>
<style lang="scss" scoped>
.patent-number {
  padding-left: 0.75rem;
}
</style>
